import { render, staticRenderFns } from "./MainContentAFA.vue?vue&type=template&id=612a0f19&"
import script from "./MainContentAFA.vue?vue&type=script&lang=js&"
export * from "./MainContentAFA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports